export default __webpack_public_path__ + "dc90e93c811d4cf279091c82d2db15bc.svg";